import { render } from "./loader-view.vue?vue&type=template&id=5a8e5d11&scoped=true"
const script = {}

import "./loader-view.vue?vue&type=style&index=0&id=5a8e5d11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8e5d11"]])

export default __exports__